// play button
const desktopPlayButton = document.querySelector('.sec-Hero_VideoPlayButton-desktop')
// stop button
const desktopStopButton = document.querySelector('.sec-Hero_VideoStopButton-desktop')
// video element
const desktopVideo = document.querySelector('.sec-Hero_Video-desktop')

// mobile play button
const mobilePlayButton = document.querySelector('.sec-Hero_VideoPlayButton-mobile')
// mobile stop button
const mobileStopButton = document.querySelector('.sec-Hero_VideoStopButton-mobile')
// mobile video element
const mobileVideo = document.querySelector('.sec-Hero_Video-mobile')

console.log('Hero snippet loaded');

function playDesktopVideo() {
    console.log('Play desktop video');
    desktopVideo.style.display = 'flex';
    desktopPlayButton.style.display = 'none';
    desktopStopButton.style.display = 'flex';
    desktopVideo.play();
}

function stopDesktopVideo() {
    console.log('Stop desktop video');
    desktopVideo.style.display = 'none';
    desktopPlayButton.style.display = 'flex';
    desktopStopButton.style.display = 'none';
    desktopVideo.pause();
    desktopVideo.currentTime = 0;
}

function playMobileVideo() {
    console.log('Play mobile video');
    mobileVideo.style.display = 'flex';
    mobilePlayButton.style.display = 'none';
    mobileStopButton.style.display = 'flex';
    mobileVideo.play();
}

function stopMobileVideo() {
    console.log('Stop mobile video');
    mobileVideo.style.display = 'none';
    mobilePlayButton.style.display = 'flex';
    mobileStopButton.style.display = 'none';
    mobileVideo.pause();
    mobileVideo.currentTime = 0;
}

if (desktopPlayButton) {
    desktopPlayButton.addEventListener('click', playDesktopVideo);
}

if (desktopStopButton) {
    desktopStopButton.addEventListener('click', stopDesktopVideo);
}

if (mobilePlayButton) {
    mobilePlayButton.addEventListener('click', playMobileVideo);
}

if (mobileStopButton) {
    mobileStopButton.addEventListener('click', stopMobileVideo);
}

// Hero parallax: scroll-based transform on sections with data-hero-parallax-wrapper
const PARALLAX_AMOUNT_MOBILE = 140
const PARALLAX_AMOUNT_DESKTOP = 200
const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)')
const SMALL_VIEWPORT_QUERY = window.matchMedia('(max-width: 767px)')

function getElementOffsetTop (element) {
  const rect = element.getBoundingClientRect()
  return rect.top + (window.scrollY ?? window.pageYOffset)
}

function setupParallaxForHeroSection (heroSection) {
  const parallaxWrapper = heroSection.querySelector('[data-hero-parallax-wrapper]')
  if (!parallaxWrapper || parallaxWrapper._parallaxInitialised) return
  parallaxWrapper._parallaxInitialised = true

  let isTicking = false
  let lastScrollY = window.scrollY ?? window.pageYOffset

  function applyParallaxTransform () {
    isTicking = false
    const sectionHeight = heroSection.getBoundingClientRect().height || heroSection.offsetHeight || 0
    if (!sectionHeight) return

    const parallaxAmountPx = SMALL_VIEWPORT_QUERY.matches ? PARALLAX_AMOUNT_MOBILE : PARALLAX_AMOUNT_DESKTOP
    const sectionTopOffset = getElementOffsetTop(heroSection)
    const scrollRangeStart = sectionTopOffset - window.innerHeight
    const scrollRangeEnd = sectionTopOffset + sectionHeight

    let transformTranslateY
    if (lastScrollY <= scrollRangeStart) {
      transformTranslateY = -parallaxAmountPx / 2
    } else if (lastScrollY >= scrollRangeEnd) {
      transformTranslateY = parallaxAmountPx / 2
    } else {
      const scrollProgress = (lastScrollY - scrollRangeStart) / (scrollRangeEnd - scrollRangeStart)
      transformTranslateY = parallaxAmountPx * scrollProgress - parallaxAmountPx / 2
    }

    parallaxWrapper.style.transform = `translate3d(0, ${Math.round(transformTranslateY)}px, 0)`
  }

  function onParallaxScroll () {
    lastScrollY = window.scrollY ?? window.pageYOffset
    if (!isTicking) {
      isTicking = true
      requestAnimationFrame(applyParallaxTransform)
    }
  }

  window.addEventListener('scroll', onParallaxScroll, { passive: true })
  requestAnimationFrame(() => {
    requestAnimationFrame(applyParallaxTransform)
  })
}

function initHeroParallaxSections () {
  if (REDUCED_MOTION_QUERY.matches) return

  const heroSections = document.querySelectorAll('.sec-Hero')
  heroSections.forEach((heroSection) => {
    if (heroSection.querySelector('[data-hero-parallax-wrapper]')) {
      setupParallaxForHeroSection(heroSection)
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroParallaxSections)
} else {
  initHeroParallaxSections()
}

document.addEventListener('shopify:section:load', (event) => {
  const loadedSection = event.target.querySelector('.sec-Hero')
  if (loadedSection?.querySelector('[data-hero-parallax-wrapper]')) {
    setupParallaxForHeroSection(loadedSection)
  }
})